import React, { useState } from 'react';
import './Subscription.css';

const PLANS = {
  trading: [
    {
      duration: '1 Month',
      period: 'monthly',
      price: '999',
      priceNum: 999,
      badge: null,
      features: [
        'Daily Crypto Trading Calls',
        'Daily Indian Market Calls (Equity)',
        'Intraday & Swing Signals',
        'Entry, Stop Loss & Target',
        'Private Telegram Channel',
        'Weekend Market Analysis',
        'WhatsApp Support',
      ],
    },
    {
      duration: '3 Months',
      period: 'quarterly',
      price: '₹1,999',
      priceNum: 1999,
      badge: 'Save ₹1,000',
      features: [
        'Everything in Monthly Plan',
        '3 Months Live Trading Calls',
        'Monthly Performance Review',
        'F&O Option Calls',
        'Priority WhatsApp Support',
        'Monthly Webinar Session',
        '1 Mentoring Call Included',
      ],
    },
    {
      duration: '6 Months',
      period: 'half-yearly',
      price: '₹3,999',
      priceNum: 3999,
      badge: 'Best Value – Save ₹2,000',
      features: [
        'Everything in 3-Month Plan',
        '6 Months Live Trading Calls',
        'Bi-Weekly Strategy Sessions',
        'Crypto & Indian Market Calls',
        '3 Mentoring Calls Included',
        'Portfolio Review Session',
        'VIP Telegram Access',
        'Course Access (1 Course Free)',
      ],
    },
  ],
  investing: [
    {
      duration: '1 Month',
      period: 'monthly',
      price: '₹299',
      priceNum: 299,
      badge: null,
      features: [
        'Monthly Stock Picks (NSE/BSE)',
        'Crypto Investment Ideas',
        'Fundamental Analysis Reports',
        'Weekly Portfolio Updates',
        'Telegram Channel Access',
        'Risk Assessment for Each Call',
        'WhatsApp Support',
      ],
    },
    {
      duration: '3 Months',
      period: 'quarterly',
      price: '₹599',
      priceNum: 599,
      badge: 'Save ₹300',
      features: [
        'Everything in Monthly Plan',
        'Quarterly Investment Roadmap',
        'Mid/Large Cap Recommendations',
        'Crypto Portfolio Allocation',
        'Priority Telegram Support',
        '1 Investment Review Call',
      ],
    },
    {
      duration: '6 Months',
      period: 'half-yearly',
      price: '₹1,299',
      priceNum: 1299,
      badge: 'Best Value – Save ₹600',
      features: [
        'Everything in 3-Month Plan',
        '6 Months Investment Calls',
        'Yearly Investment Planning',
        'IPO & NFO Guidance',
        'Crypto Long-Term Strategy',
        '3 Portfolio Review Calls',
        'VIP Community Access',
        'Tax Saving Investment Tips',
      ],
    },
  ],
};

const Subscription = () => {
  const [activeTab, setActiveTab] = useState('trading');
  const WHATSAPP_NUMBER = '919926749937';

  const currentPlans = PLANS[activeTab];

  return (
    <div className="subscription-page">
      <section className="page-hero section-padding grid-bg">
        <div className="hero-glow-small" />
        <div className="container">
          <div className="tag">Subscription Plans</div>
          <h1 className="section-title">Simple Pricing,<br /><span className="gold-text">Maximum Returns</span></h1>
          <p className="section-subtitle">
            Get live trading and investment calls directly from a 4+ year market veteran.
            Pick your plan, join the channel, and start profiting.
          </p>
        </div>
      </section>

      <section className="subscription-section section-padding">
        <div className="container">
          {/* Tabs */}
          <div className="plan-tabs">
            <button
              className={`plan-tab ${activeTab === 'trading' ? 'active' : ''}`}
              onClick={() => setActiveTab('trading')}
            >
              📈 Trading Calls
            </button>
            <button
              className={`plan-tab ${activeTab === 'investing' ? 'active' : ''}`}
              onClick={() => setActiveTab('investing')}
            >
              💼 Investing Calls
            </button>
          </div>

          {/* Tab Description */}
          <div className="tab-desc">
            {activeTab === 'trading' ? (
              <p>🔥 Live buy/sell signals for <strong>Crypto & Indian Stock Markets</strong>. Intraday, swing, and positional trading calls with precise entry, SL and targets.</p>
            ) : (
              <p>📊 Long-term investment recommendations for <strong>Stocks, Crypto & Mutual Funds</strong>. Build wealth systematically with expert guidance.</p>
            )}
          </div>

          {/* Plans Grid */}
          <div className="plans-grid">
            {currentPlans.map((plan, i) => (
              <div className={`plan-card card ${i === 2 ? 'featured' : ''}`} key={i}>
                {i === 2 && <div className="plan-featured-label">⭐ Most Popular</div>}
                {plan.badge && (
                  <div className="plan-badge">{plan.badge}</div>
                )}
                <div className="plan-duration">{plan.duration}</div>
                <div className="plan-period">{plan.period}</div>
                <div className="plan-price-block">
                  <span className="plan-price">{plan.price}</span>
                  <span className="plan-per-day">{plan.perDay}</span>
                </div>
                <ul className="plan-features">
                  {plan.features.map((f, j) => (
                    <li key={j}>
                      <span className="feat-check">✓</span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Hi Kalpnic Trading! I want to subscribe to the ${plan.duration} ${activeTab === 'trading' ? 'Trading Calls' : 'Investing Calls'} plan at ${plan.price}.`)}`}
                  target="_blank"
                  rel="noreferrer"
                  className={i === 2 ? 'btn-gold plan-btn' : 'btn-outline plan-btn'}
                >
                  Subscribe Now
                </a>
              </div>
            ))}
          </div>

          {/* Combo Offer */}
          <div className="combo-offer">
            <div className="combo-inner">
              <div className="combo-badge">🔥 COMBO DEAL</div>
              <h3>Trading + Investing Combo</h3>
              <p>Get both Trading Calls AND Investing Calls together at a discounted bundle price!</p>
              <div className="combo-prices">
                <div className="combo-price-item">
                  <span>1 Month Combo</span>
                  <span className="combo-price">₹1,099 <span className="combo-orig">₹1,298</span></span>
                </div>
                <div className="combo-price-item">
                  <span>3 Months Combo</span>
                  <span className="combo-price">₹2,199 <span className="combo-orig">₹2,598</span></span>
                </div>
                <div className="combo-price-item">
                  <span>6 Months Combo</span>
                  <span className="combo-price">₹4,999 <span className="combo-orig">₹5,298</span></span>
                </div>
              </div>
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hi! I want to subscribe to the Trading + Investing Combo plan.')}`}
                target="_blank"
                rel="noreferrer"
                className="btn-gold"
              >
                Get Combo Deal
              </a>
            </div>
          </div>

          {/* Trust Signals */}
          <div className="trust-signals">
            <div className="trust-item">🔒 Secure Payments via UPI/Bank Transfer</div>
            <div className="trust-item">📱 Instant WhatsApp Onboarding</div>
            <div className="trust-item">📊 Daily Calls on Telegram</div>
            <div className="trust-item">💯 Real Results, Real Traders</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Subscription;
